import { render, staticRenderFns } from "./CoinFlowManagement.vue?vue&type=template&id=f2564924&scoped=true"
import script from "./CoinFlowManagement.vue?vue&type=script&lang=js"
export * from "./CoinFlowManagement.vue?vue&type=script&lang=js"
import style0 from "./CoinFlowManagement.vue?vue&type=style&index=0&id=f2564924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2564924",
  null
  
)

export default component.exports